export default "/_next/static/assets/images/video-player-sprite.47d472e0a7582405c86eec23a3e82c40.svg";